<template>
  <div class="Products">
    <v-container fluid>
      <v-row dense>
        <v-btn
          color="deep-purple lighten-2"
          outlined
          rounded
          @click="openDialog(null)"
          v-if="level <= 2"
        >
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
        <v-col
          v-for="product in products"
          :key="product.id"
          :cols="12"
          md="3"
          sm="12"
        >
          <v-card
            :loading="loading"
            class="mx-auto"
            max-width="374"
          >
            <template slot="progress">
              <v-progress-linear
                  color="deep-purple"
                  height="10"
                  indeterminate
              />
            </template>

            <v-img
              height="250"
              :src="product.src"
            >
            </v-img>

            <v-card-title>{{ product.title }}</v-card-title>

            <v-card-text>
              <div>{{ product.content }}</div>
            </v-card-text>

            <v-divider class="mx-4"></v-divider>

            <div class='overflow-hidden' v-if="grade > 0 && product.dcFlag === 'Y'">
              <v-card-title v-if="grade === 1">{{ product.discountPrice_1 | currency }} 원</v-card-title>
              <v-card-title v-else-if="grade === 2">{{ product.discountPrice_2 | currency }} 원</v-card-title>
              <v-card-title v-else-if="grade === 3">{{ product.discountPrice_3 | currency }} 원</v-card-title>
              <v-card-subtitle class='text-decoration-line-through'>{{ product.price | currency }} 원</v-card-subtitle>
            </div>
            <div v-else-if="grade > 0 && product.dcFlag === 'N'">
              <v-card-title>{{ product.price | currency }} 원</v-card-title>
            </div>
            <div v-else>
              <v-card-subtitle>{{ product.price | currency }} 원</v-card-subtitle>
            </div>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="deep-purple lighten-2"
                text
                outlined
                rounded
                @click="openOrder(product)"
              >
                구매하기
              </v-btn>
              <v-btn
                color="deep-purple lighten-2"
                text
                outlined
                rounded
                v-if="product.link"
                v-bind:href="product.link"
                target="_blank"
              >
                자세히보기
              </v-btn>
              <v-btn
                color="deep-purple lighten-2"
                text
                outlined
                rounded
                @click="openDialog(product)"
                v-if="level <= 2"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <v-btn
                color="deep-purple lighten-2"
                text
                outlined
                rounded
                @click="openDialog2(product)"
                v-if="level <= 2"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
      <v-dialog max-width="500px" v-model="dialog">
        <v-card>
          <v-form>
            <v-card-text>
              <v-text-field
                v-model="form.title"
                label="상품 제목"
              ></v-text-field>
              <v-text-field
                v-model="form.content"
                label="간단 설명"
              ></v-text-field>
              <v-text-field
                v-model="form.price"
                label="상품 금액"
              ></v-text-field>
              <v-text-field
                v-model="form.discountPrice_1"
                label="할인 금액 1"
              ></v-text-field>
              <v-text-field
                v-model="form.discountPrice_2"
                label="할인 금액 2"
              ></v-text-field>
              <v-text-field
                v-model="form.discountPrice_3"
                label="할인 금액 3"
              ></v-text-field>
              <v-text-field
                v-model="form.link"
                label="상품 자세히보기"
              ></v-text-field>

              <div
                v-if="!form.src"
              >
                <v-file-input
                  v-model="thumbImage"
                  :rules="thumbRules"
                  accept="image/png, image/jpeg, image/bmp"
                  placeholder="썸네일 사진을 등록해주세요"
                  prepend-icon="mdi-camera"
                  label="썸네일"
                  @change="imageUpload"
                  ref="files"
                ></v-file-input>
              </div>
              <div
                v-else
              >
                <v-card>
                  <v-img
                    :src="form.src"
                  >
                    <v-app-bar
                      flat
                      color="rgba(0, 0, 0, 0)"
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        color="white"
                        icon
                        @click="form.src = null"
                      >
                        <v-icon>
                          mdi-close-box
                        </v-icon>
                      </v-btn>
                    </v-app-bar>
                  </v-img>
                </v-card>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn @click="save()">저장</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
      <v-dialog max-width="500px" v-model="dialog2">
        <v-card>
          <v-card-title>
            <span class="headline">한번 삭제 하면 되돌릴 수 없습니다.</span>
          </v-card-title>
          <v-card-text>
            삭제하시겠습니까?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="red darken-1"
              text
              @click="remove"
            >
              삭제
            </v-btn>
            <v-btn
              text
              @click="dialog2 = false"
            >
              취소
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-bottom-sheet
        v-model="orderSheet"
        inset
      >
        <v-sheet
          class="text-center"
          height="184px"
        >
          <v-card>
            <div class="d-flex flex-no-wrap justify-space-between">
              <div>
                <v-card-title
                  class="subtitle-1 text-center ellips"
                  v-text="orderItems.title"
                ></v-card-title>

                <v-card-subtitle
                  class="pb-0"
                  v-if="grade === 1"
                >
                  {{ orderItems.discountPrice_1 | currency }} 원
                </v-card-subtitle>
                <v-card-subtitle
                  class="pb-0"
                  v-if="grade === 2"
                >
                  {{ orderItems.discountPrice_2 | currency }} 원
                </v-card-subtitle>
                <v-card-subtitle
                  class="pb-0"
                  v-if="grade === 3"
                >
                  {{ orderItems.discountPrice_3 | currency }} 원
                </v-card-subtitle>
                <v-card-subtitle
                  class="pb-0"
                  v-if="grade < 1"
                >
                  {{ orderItems.price | currency }} 원
                </v-card-subtitle>

                <v-card-text
                  class="pb-0"
                >
                  <v-select
                    v-model="orderItems.Quantity"
                    :items="count"
                    :menu-props="{ top: true, offsetY: true }"
                    label="수량"
                  ></v-select>
                </v-card-text>

                <v-card-actions>
                  <v-btn
                    outlined
                    small
                    block
                    @click="orderProducts(orderItems)"
                  >
                    구매
                  </v-btn>
                  <!-- <v-btn
                    class="ml-2 mt-5"
                    outlined
                    small
                  >
                    주문
                  </v-btn> -->
                </v-card-actions>
              </div>

              <v-avatar
                class="ma-3"
                size="160"
                tile
              >
                <v-img :src="orderItems.src"></v-img>
              </v-avatar>
            </div>
          </v-card>
        </v-sheet>
      </v-bottom-sheet>
      <div
        v-if="loadingBox"
        class="d-flex align-center justify-center"
        style="position: fixed; left: 0; top: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, .2); z-index: 999"
      >
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
    </v-container>
  </div>
</template>

<script>
export default {
  data () {
    return {
      dialog: false,
      dialog2: false,
      dialog3: false,
      loading: false,
      loadingBox: false,
      orderSheet: false,
      unsubscribe: null,
      selectedItem: null,
      selectProduct: null,
      thumbImage: null,
      level: 5,
      grade: 0,
      selection: 1,
      products: [],
      form: {
        title: '',
        content: '',
        price: '',
        discountPrice_1: '',
        discountPrice_2: '',
        discountPrice_3: '',
        src: '',
        link: '',
        dcFlag: ''
      },
      thumbRules: [
        value => !value || value.size < 2000000 || '이미지 크기는 2 MB 이하로 제한됩니다!'
      ],
      orderItems: {
        title: '시마바라 소면',
        price: '100000'
      },
      count: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10']
    }
  },

  created () {
    this.subscribe()
  },

  destroyed () {
    if (this.unsubscribe) this.unsubscribe()
  },

  filters: {
    currency (value) {
      return String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
  },

  methods: {
    subscribe () {
      var _this = this

      var userID = _this.$firebase.auth().currentUser.uid

      _this.unsubscribe = _this.$firebase.firestore().collection('products').onSnapshot((sn) => {
        if (sn.empty) {
          _this.products = []
          return
        }

        _this.products = sn.docs.map(v => {
          const product = v.data()
          console.log('1: ' + product.dcFlag)
          if (product.dcFlag === 'Y') {
            return {
              id: v.id,
              title: product.title,
              content: product.content,
              price: product.price,
              discountPrice_1: product.discountPrice_1,
              discountPrice_2: product.discountPrice_2,
              discountPrice_3: product.discountPrice_3,
              dcFlag: product.dcFlag, // 할인금액 유무(Y/N)
              src: product.src,
              link: product.link,
              flex: 3
            }
          } else if (product.dcFlag === 'N') {
            return {
              id: v.id,
              title: product.title,
              content: product.content,
              price: product.price,
              discountPrice_1: product.price,
              discountPrice_2: product.price,
              discountPrice_3: product.price,
              dcFlag: product.dcFlag, // 할인금액 유무(Y/N)
              src: product.src,
              link: product.link,
              flex: 3
            }
          }
          // return {
          //   id: v.id,
          //   title: product.title,
          //   content: product.content,
          //   price: product.price,
          //   discountPrice_1: product.discountPrice_1,
          //   discountPrice_2: product.discountPrice_2,
          //   discountPrice_3: product.discountPrice_3,
          //   dcFlag: product.dcFlag, // 할인금액 유무(Y/N)
          //   src: product.src,
          //   link: product.link,
          //   flex: 3
          // }
        })
      })
      _this.$firebase.database().ref('users/' + userID).once('value').then(function (snapshot) {
        if (snapshot.empty) {
          return
        }
        _this.level = (snapshot.val() && snapshot.val().level) || '0'
        _this.grade = (snapshot.val() && snapshot.val().grade) || '0'
        _this.uName = snapshot.val().displayName
        _this.uCompnay = snapshot.val().company

        console.log('grade: ' + _this.grade)
        console.log('leve: ' + _this.level)
        console.log('uName: ' + _this.uName)
        console.log('uCompany: ' + _this.uCompnay)
      })
    },

    openDialog (product) {
      this.dialog = true
      this.selectedItem = product

      const fm = this.form

      if (!product) {
        fm.title = ''
        fm.content = ''
        fm.price = ''
        fm.src = ''
        fm.link = ''
        fm.dcFlag = ''
      } else {
        fm.title = product.title
        fm.content = product.content
        fm.price = product.price
        fm.src = product.src
        fm.link = product.link
        fm.dcFlag = product.dcFlag
        // console.log('0: ' + fm.dcFlag)
      }
    },

    openDialog2 (product) {
      this.dialog2 = true

      this.selectProduct = product
    },

    openDialog3 () {
      this.orderDialog = true
    },

    openOrder (product) {
      var _this = this

      var userID = _this.$firebase.auth().currentUser.uid
      _this.$firebase.database().ref('users/' + userID).once('value').then(function (snapshot) {
        if (snapshot.empty) {
          return
        }
        _this.uName = snapshot.val().displayName
        // console.log(_this.uName)
      })
      console.log('2: ' + product.dcFlag)
      if (product.dcFlag === 'Y') {
        _this.orderSheet = !_this.orderSheet
        _this.orderItems.productID = product.id
        _this.orderItems.title = product.title
        _this.orderItems.price = product.price
        _this.orderItems.discountPrice_1 = product.discountPrice_1
        _this.orderItems.discountPrice_2 = product.discountPrice_2
        _this.orderItems.discountPrice_3 = product.discountPrice_3
        _this.orderItems.src = product.src
        _this.orderItems.dcFlag = product.dcFlag
        _this.orderItems.userID = userID
        _this.orderItems.dispalyName = _this.uName
      } else if (product.dcFlag === 'N') {
        _this.orderSheet = !_this.orderSheet
        _this.orderItems.productID = product.id
        _this.orderItems.title = product.title
        _this.orderItems.price = product.price
        _this.orderItems.discountPrice_1 = product.price
        _this.orderItems.discountPrice_2 = product.price
        _this.orderItems.discountPrice_3 = product.price
        _this.orderItems.src = product.src
        _this.orderItems.dcFlag = product.dcFlag
        _this.orderItems.userID = userID
        _this.orderItems.dispalyName = _this.uName
      }
      // _this.orderSheet = !_this.orderSheet
      // _this.orderItems.productID = product.id
      // _this.orderItems.title = product.title
      // _this.orderItems.price = product.price
      // _this.orderItems.discountPrice_1 = product.discountPrice_1
      // _this.orderItems.discountPrice_2 = product.discountPrice_2
      // _this.orderItems.discountPrice_3 = product.discountPrice_3
      // _this.orderItems.src = product.src
      // _this.orderItems.dcFlag = product.dcFlag
      // _this.orderItems.userID = userID
      // _this.orderItems.dispalyName = _this.uName
      // console.log('1: ' + product.dcFlag)
    },

    async orderProducts (product) {
      var orderData = {
        productID: product.productID,
        Quantity: product.Quantity
      }

      if (!orderData.Quantity) {
        alert('상품 구매 수량은 선택해주세요.')
      } else if (orderData.Quantity > 0) {
        this.$router.push({ name: 'Orders', params: orderData })
      }
    },

    async imageUpload () {
      var storageRef = this.$firebase.storage().ref()

      var file = this.thumbImage

      var fm = this.form

      var metadata = {
        contentType: 'image/jpeg'
      }

      var uploadTask = storageRef.child('images/thumb/' + file.name).put(file, metadata)

      await uploadTask.on('state_changed',
        function (snapshot) {
          var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100

          console.log(progress + '%')

          switch (snapshot.state) {
            case 'paused':
              break
            case 'running':
              break
          }
        }, function (error) {
          console.log(error)
        }, function () {
          uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
            fm.src = downloadURL
          })
        }
      )
    },

    async save () {
      if (!this.selectedItem) {
        this.$firebase.firestore().collection('products').add(this.form)

        if (this.form.src) {
          await this.$firebase.storage().ref().child(this.form.src)
        }
      } else {
        this.$firebase.firestore().collection('products').doc(this.selectedItem.id).update(this.form)
      }

      this.dialog = false
    },

    remove () {
      this.$firebase.firestore().collection('products').doc(this.selectProduct.id).delete()

      this.dialog2 = false
    }
  }
}
</script>
